import React from "react";
import { Box, Button } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  stopImpersonation,
  fetchFeatures,
  clearConfig,
} from "../../../../redux/slices/appSlice";
import { useSelector, useDispatch } from "react-redux";

const StopImpersonate = () => {
  const dispatch = useDispatch();
  const handleStopImpersonation = () => {
    dispatch(stopImpersonation());
    dispatch(fetchFeatures());
    dispatch(clearConfig());
  };
  const { companyId } = useSelector((state) => state.app);
  return (
    <>
      <Button
        onClick={handleStopImpersonation}
        variant="contained"
        color="secondary"
        sx={{
          position: "fixed",
          bottom: 16,
          right: 520,
          zIndex: 1001,
          backgroundColor: "red",
          "&:hover": {
            backgroundColor: "#cc0000",
          },
        }}
        startIcon={<CancelIcon />}
      >
        Stop Impersonating
      </Button>
      <Box
        sx={{
          backgroundColor: "red",
          color: "white",
          textAlign: "center",
          padding: "4px 8px",
          fontSize: "14px",
          position: "fixed",
          bottom: 60,
          right: 500,
          zIndex: 1000,
          fontWeight: "bold",
          borderRadius: "4px",
        }}
      >
        You are impersonating Company ID: {companyId}
      </Box>
    </>
  );
};
export default StopImpersonate;
